import { Locale } from "../schema/Locale.js";
import type { VertiNodeTenant } from "../schema/VertiNodeTenant.js";
import { VertiNodeTenantId } from "../schema/VertiNodeTenant.js";
import { isEnum } from "../utils/enum/isEnum.js";
import vertiNodeTenants from "./vertinode-tenants.json" with { type: "json" };

const isLocale = isEnum(Locale);
const isVertiNodeTenantId = isEnum(VertiNodeTenantId);

function isVertiNodeTenant(obj: unknown): obj is VertiNodeTenant {
	return (
		obj !== null &&
		typeof obj === "object" &&
		"id" in obj &&
		isVertiNodeTenantId(obj.id) &&
		"locale" in obj &&
		isLocale(obj.locale)
	);
}

const map: Partial<Record<VertiNodeTenantId, VertiNodeTenant>> = {};
try {
	if (!Array.isArray(vertiNodeTenants)) {
		throw new Error("Not an array");
	}
	if (vertiNodeTenants.length !== Object.values(VertiNodeTenantId).length) {
		throw new Error("Record count does not match");
	}
	for (const tenant of vertiNodeTenants) {
		if (!isVertiNodeTenant(tenant)) {
			throw new Error("Invalid record");
		}
		if (map[tenant.id]) {
			throw new Error("Duplicate tenant ID found");
		}
		map[tenant.id] = tenant;
	}
} catch (err) {
	throw new Error(`VertiNodeTenants config invalid: ${String(err)}`);
}
const frozen = Object.freeze(map as Record<VertiNodeTenantId, VertiNodeTenant>);
export { frozen as vertiNodeTenants };
